import { createAction, RSAASuccessType } from 'redux-api-middleware'
import { ActionsTypes, ApiCallType } from './types'

interface WFHActionsTypes extends ActionsTypes {
    DCG_PRODUCT_INFORMATION: ApiCallType
}

const Types: WFHActionsTypes = {
    DCG_PRODUCT_INFORMATION: {
        request: 'DCG_PRODUCT_INFORMATION##REQUEST',
        success: 'DCG_PRODUCT_INFORMATION##SUCCESS',
        failure: 'DCG_PRODUCT_INFORMATION##FAILURE',
    },
}

interface DCGProductInformationMeta {
    secondaryType?: string
}

/**
 * Fetch DCG products information
 * @param {string[]} skus List of skus
 */
function fetchDCGProductsInformation(skus: string[], meta: DCGProductInformationMeta = {}) {
    const body = {
        query: `query getProducts($skus: [String!]!) {
      timestamp
      getProducts(skus: $skus) {
        sku
        images {
          url
        }
        link
        title {
          en_gb
        }
      }
    }`,
        variables: { skus },
    }

    const buildSuccessType = (): RSAASuccessType => {
        const successType = Types.DCG_PRODUCT_INFORMATION.success
        const { secondaryType } = meta

        if (secondaryType) {
            return {
                type: successType,
                meta: { secondaryType },
            }
        }

        return successType
    }

    return createAction({
        endpoint: 'https://dcg-products.volumenetwork.com/graphql',
        method: 'POST',
        body: JSON.stringify(body),
        types: [Types.DCG_PRODUCT_INFORMATION.request, buildSuccessType(), Types.DCG_PRODUCT_INFORMATION.failure],
    })
}

export { Types, fetchDCGProductsInformation }
